<template>
<v-list class='grey lighten-4 ma-0 pa-0' :dense='dense' >
  <practitioner-list-item
    :item='selected'
    @selected='showmenu=true' >
    <template slot='title' slot-scope="props" >
      <v-list-item-title v-if='props.fullname'>{{ props.fullname }}</v-list-item-title>
      <v-list-item-title v-else >Choose a practitioner</v-list-item-title>
    </template>

    <v-list-item-action slot='actions' >
      <v-menu v-model='showmenu' nudge-bottom close-on-click >
        <template v-slot:activator="{ on }">
        <v-btn v-on='on' slot='activator' small icon >
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
        </template>
        <v-list dense class='pa-0' style='width:300px;'
          v-for='(practitioner, index) in practitioners' :key='practitioner.id' >
          <practitioner-list-item
            :item='practitioners[index]'
            @selected="setSelected"
            badge-color='success'
            :badge-icon='getSelectedIcon(practitioner)'
            :class='{"blue lighten-5": isSelected(practitioner)}' >
          </practitioner-list-item>
        </v-list>
      </v-menu>
    </v-list-item-action>
  </practitioner-list-item>
  <!-- {{spaceId}}: {{practitioners.length}} -->
</v-list>
</template>
<script>
import PractitionerListItem from '@/components/listitems/PractitionerListItem'
import { mapGetters } from 'vuex'
// import Vue from 'vue'
export default {
  name: 'PractitionerPicker',
  components: {PractitionerListItem},
  props: {
    value: { type: Object },
    dense: { type: Boolean, default: true },
    excludeIds: { type: Array, default: () => { return [] } },
    spaceId: { required: false }
  },
  data () {
    return {
      showmenu: false,
      selected: {}
    }
  },
  methods: {
    isSelected (practitioner) {
      return practitioner.id === this.practitionerId
    },
    getSelectedIcon (practitioner) {
      if (this.isSelected(practitioner)) {
        return 'check'
      }
      return null
    },
    setSelected (practitioner) {
      // Vue.set(this.selected, practitioner)
      this.selected = practitioner
      this.$emit('input', this.selected)
      this.$emit('selected', this.selected)
    }
  },
  mounted () {
    if  (!this.selected && this.meId) {
      this.selected = this.meId
      this.$emit('input', this.selected)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) {
          this.selected = this.value
        }
      }
    },
    meId () {
      if (!this.selected.id) {
        this.selected = this.me
        this.$emit('input', this.selected)
      }
    }
  },
  computed: {
    ...mapGetters('identity', [
      'me',
      'meId',
      'lookups',
      'practitionersList',
      'getPractitionerById',
      'getPractitionersInSpace'
    ]),
    practitionerId () {
      if (this.selected && this.selected) { return this.selected.id }
      return null
    },
    practitioners () {
      let ps = []
      if (this.spaceId) {
        ps = this.getPractitionersInSpace(this.spaceId)
      } else {
        ps = this.practitionersList
      }
      if (this.excludeIds && this.excludeIds.length > 0) {
        ps = ps.filter((p) => {
          return this.excludeIds.indexOf(p.id) === -1
        })
      }
      return ps
    },
    practitioner () {
      let practitionerId = this.practitionerId
      if (!practitionerId) { practitionerId = this.meId }
      return this.getPractitionerById(practitionerId)
    }
  }
}
</script>
<style scoped>
.selected { color: red; }
</style>
